import MoreVertIcon from '@mui/icons-material/MoreVertOutlined'
import { MenuItem, MenuList, Popover } from '@mui/material'
import React from 'react'

import * as S from './styles'

export interface CardMenuItem {
  disabled?: boolean
  label: string
  testId?: string
  onSelect: () => void
}

export interface CardMenuProps {
  className?: string
  disabled?: boolean
  menuItems: CardMenuItem[]
}

const CardMenu: React.FC<CardMenuProps> = ({ className, disabled, menuItems, ...rest }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const isOpen = !!anchorEl

  const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setAnchorEl((prevAnchor) => (prevAnchor === null ? e.currentTarget : null))
    e.currentTarget.focus()
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault()
      handleClose()
    }
  }

  const handleMenuClick = (index: number) => {
    menuItems[index].onSelect()
    handleClose()
  }

  return (
    <div className={className} {...rest}>
      <S.IconButton
        aria-label="More"
        aria-owns={isOpen ? 'long-menu' : undefined}
        aria-haspopup="true"
        color="primary"
        disabled={disabled}
        onClick={handleToggle}
      >
        <MoreVertIcon />
      </S.IconButton>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={(e: React.SyntheticEvent) => {
          e.stopPropagation()
          handleClose()
        }}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        slotProps={{
          paper: {
            sx: {
              marginTop: 1,
            },
          },
        }}
      >
        <MenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={handleListKeyDown}>
          {menuItems.map((menuItem, menuItemIndex) => (
            <MenuItem
              disabled={menuItem.disabled}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                handleMenuClick(menuItemIndex)
              }}
              key={menuItem.label}
              data-test={menuItem.testId}
            >
              {menuItem.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </div>
  )
}

CardMenu.displayName = 'CardMenu'
export default CardMenu
